import React from "react";

const Container = ({
  children,
  className = "",
  ...props
}: {
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={`max-w-[1200px] px-4 mx-auto ${className}`.trim()}
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;
